const flatten = require('flat');

export const auth = {
  methods: {
    isAdminOfGroup(group) {
      return group.isAdmin;
    },
    isAdminOrManagerOfGroup(group) {
      return (group.isAdmin || group.isManager);
    },
    isManagerOfGroup(group) {
      return group.isManager;
    },
  },
  computed: {
    username() {
      return this.$store.state.pid;
    },
    isAdminOfCurrentGroup() {
      return this.isAdminOfGroup(this.$store.state.currentGroup.managedGroup);
    },
    isAdminOrManagerOfCurrentGroup() {
      return this.isAdminOrManagerOfGroup(this.$store.state.currentGroup.managedGroup);
    },
    isManagerOfCurrentGroup() {
      return this.isManagerOfGroup(this.$store.state.currentGroup.managedGroup);
    },
  },
};

export const groupRoles = {
  computed: {
    personAdministrators() {
      return this.$store.getters.groupAdministrators(this.managedGroup, 'person');
    },
    serviceAdministrators() {
      return this.$store.getters.groupAdministrators(this.managedGroup, 'service');
    },
    personManagers() {
      return this.$store.getters.groupManagers(this.managedGroup, 'person');
    },
    serviceManagers() {
      return this.$store.getters.groupManagers(this.managedGroup, 'service');
    },
    serviceViewers() {
      return this.$store.getters.groupViewers(this.managedGroup, 'service');
    },
    personContacts() {
      return this.$store.getters.groupContacts(this.managedGroup, 'person');
    },
  },
};

export const groupsFetch = {
  data() {
    return {
      fetchingGroups: false,
      // Roles used to determine which groups to fetch from ED for the current user. Note: not all roles are
      // necessary for all components using this mixin, so the component should override this value if necessary.
      userRoles: ['administrator', 'manager', 'contact', 'viewer'],
      // Group roles to be included in the group list from ED. Note: not all roles are necessary for all components,
      // so the component should override this value if necessary.
      withRoles: ['administrators', 'managers', 'members'],
    };
  },
  methods: {
    fetchGroups() {
      const vm = this;
      vm.fetchingGroups = true;
      vm.$store.dispatch('fetchGroupsForUserFromEd', { userRoles: vm.userRoles, withRoles: vm.withRoles })
        .finally(() => {
          vm.fetchingGroups = false;
        });
    },
  },
  created() {
    const vm = this;
    if (!vm.$store.state.groupsFetched || !vm.$store.state.groupMembersFetched) {
      return this.fetchGroups();
    }
  },
};

export const groupsMixin = {
  computed: {
    managedGroup() {
      return this.$store.state.currentGroup.managedGroup;
    },
  },
  methods: {
    nestedSortCompare(valOne, valTwo, key) {
      if (typeof valOne[key] === 'number' && typeof valTwo[key] === 'number') {
        // If both fields are numbers
        if (valOne[key] < valTwo[key]) {
          return -1;
        } else if (valOne[key] > valTwo[key]) {
          return 1;
        }
        return 0;
      }
      // Flatten the nested values and compare.
      return (flatten(valOne)[key]).toString().localeCompare((flatten(valTwo)[key]).toString(), undefined, {
        numeric: true,
      });
    },
    scrollToElement(elementId) {
      document.getElementById(elementId).scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  },
};

export const util = {
  methods: {
    /* Convert delimited string into array, convert results to lowercase, and remove duplicates. */
    arrayFromDelimitedString(delimitedString) {
      return Array.from(new Set(delimitedString.split(/[\s,;]+/).filter(Boolean))).map(name => name.toLowerCase());
    },
    isEmpty(object) {
      if (typeof object === 'string') {
        return (!object || object.length === 0);
      }
      return Object.keys(object).length === 0;
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
  },
};



// WEBPACK FOOTER //
// ./src/util/groups-mixin.js